/* eslint-disable */
<template lang="pug">
.j-tab
  .j-tab_content
    .main-tab
      .main-tab_cell(
        v-for="(mainTab, mIndex) in tabs.main",
        @click="mainTabHandler(mIndex)",
        :class="selectedTabs.main === mainTab.id?'main-tab_activity color_text_0':'color_text_2'"
      )
        .main-tab_name {{mainTab.name}}
        .main-tab_line
    .sub-tab
      j-switch-btn.study-switch(
        v-show="showStudySwitch",
        :isActive="isStudyMode",
        @j-switch="switchStudyMode",
        label="学习模式",
      )
      .sub-tab_cell(
        v-for="(subTab, sIndex) in tabs.sub",
        @click="subTabHandler(sIndex)",
        :class="selectedTabs.sub.includes(subTab.id)?'sub-tab_activity color_label_stress color_text_stress':'color_label_2 color_text_2'"
      )
        .sub-tab_name {{subTab.name}}
        .sub-tab_status
</template>

<script>
import {
  defineComponent,
  reactive,
  ref,
  watch,
} from 'vue';
import JSwitchBtn from '@/components/JSwitchBtn.vue';

export default defineComponent({
  name: 'JTab',
  components: {
    JSwitchBtn,
  },
  props: {
    isStudy: {
      type: Boolean,
      default: false,
    },
  },
  setup(props, context) {
    const isStudyMode = ref(false);
    const showStudySwitch = ref(true);
    const selectedTabs = reactive({
      main: 'voiceless',
      sub: ['hiragana', 'katakana', 'romaji'],
    });
    const tabs = reactive({
      main: [
        {
          name: '清音',
          id: 'voiceless',
        },
        {
          name: '浊音',
          id: 'turbid',
        },
        {
          name: '拗音',
          id: 'hard',
        },
      ],
      sub: [
        {
          name: '平假名',
          id: 'hiragana',
        },
        {
          name: '片假名',
          id: 'katakana',
        },
        {
          name: '罗马音',
          id: 'romaji',
        },
      ],
    });

    watch(() => props.isStudy, (newValue) => {
      isStudyMode.value = newValue;
    });

    const mainTabHandler = (mIndex) => {
      console.log(mIndex);
      selectedTabs.main = tabs.main[mIndex].id;
      if (selectedTabs.main !== 'voiceless') {
        showStudySwitch.value = false;
      } else {
        showStudySwitch.value = true;
      }
      context.emit('j-tab-switch', selectedTabs);
    };

    const subTabHandler = (sIndex) => {
      console.log(sIndex);
      const subId = tabs.sub[sIndex].id;
      if (selectedTabs.sub.includes(subId)) {
        const removeIndex = selectedTabs.sub.indexOf(subId);
        selectedTabs.sub.splice(removeIndex, 1);
      } else {
        selectedTabs.sub.push(subId);
      }
      context.emit('j-tab-switch', selectedTabs);
    };

    const switchStudyMode = (value) => {
      isStudyMode.value = value;
      context.emit('j-switch-study', isStudyMode.value);
    };

    return {
      showStudySwitch,
      isStudyMode,
      tabs,
      selectedTabs,
      mainTabHandler,
      subTabHandler,
      switchStudyMode,
    };
  },
});
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="stylus" scoped>
  .j-tab
    .j-tab_content
      padding-bottom 0.32rem
      border-bottom 1px solid #F4F5F7
    .main-tab
      height 0.88rem
    .main-tab_cell
      position relative
      z-index 1
      margin-right 0.48rem
      display inline-block
      .main-tab_name
        line-height 0.28rem
        font-size 0.28rem
      .main-tab_line
        display none
        width 0.28rem
        height 0.28rem
        background url("../assets/ic_tab.png") 50% 50% no-repeat
        background-size contain
        margin 0 auto
    .main-tab_activity
      .main-tab_name
        font-size 0.32rem
        line-height 0.32rem
        font-weight bolder
      .main-tab_line
        display block
    .sub-tab
      height 0.46rem
    .sub-tab_cell
      display inline-block
      vertical-align top
      padding 0 0.2rem
      height 0.44rem
      line-height 0.44rem
      margin-right 0.12rem
      border 1px solid #E6E7E8
      border-radius 0.22rem
      overflow hidden
      position relative
      z-index 1
      .sub-tab_name
        font-size 0.22rem
      .sub-tab_status
        display none
        position absolute
        right 0
        bottom -1px
        width 0.2rem
        height 0.2rem
        background url("../assets/sub_tab_selected.png") 50% 50% no-repeat
        background-size contain
    .sub-tab_activity
      border 1px solid rgba(251, 74, 62, 0.7)
      .sub-tab_status
        display block
    .study-switch
      float right
</style>
<style lang="stylus">
  .dark
    .j-tab
      .j-tab_content
        border-bottom 1px solid #2F2F30
      .main-tab_cell
        .main-tab_line
          background url("../assets/ic_tab_dark.png") 50% 50% no-repeat
          background-size contain
      .sub-tab_cell
        border 1px solid #3B3C40
        .sub-tab_status
          background url("../assets/sub_tab_selected_dark.png") 50% 50% no-repeat
          background-size contain
      .sub-tab_activity
        border 1px solid rgba(255, 88, 77, 0.6)
</style>
